import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/CourseGAContextSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/GAPageViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseLayout"] */ "/vercel/path0/apps/web/src/components/course-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeedbackWidget"] */ "/vercel/path0/apps/web/src/components/feedback/widget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseNav"] */ "/vercel/path0/apps/web/src/components/nav/course-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookingSourceWrapper"] */ "/vercel/path0/apps/web/src/contexts/BookingSourceContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChannelWrapper"] */ "/vercel/path0/apps/web/src/contexts/ChannelContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CheckoutDebugWrapper"] */ "/vercel/path0/apps/web/src/contexts/CheckoutDebugContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseWrapper"] */ "/vercel/path0/apps/web/src/contexts/CourseContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FiltersWrapper"] */ "/vercel/path0/apps/web/src/contexts/FiltersContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaymentModeWrapper"] */ "/vercel/path0/apps/web/src/contexts/PaymentModeContext.tsx");
